<template>
  <div class="my_link_btn linkContent lineControl" @click="set_link" :title="title"><span class="el-icon-link"></span></div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'my_link_btn',
  data() {
    return {

    };
  },
  props:{
    module:{
      type:Object,
      default:null
    },
    title:{
      type:String,
      default:i18n.t('components_my_link_index_2361')
    }
  },
  methods:{
    set_link() {
      this.templet.set_link(this.module.data.listArr.link)
    },
  }
};
</script>

<style lang="scss" scoped>
.my_link_btn:hover {
  background-color: #2e343B;
}
</style>



// WEBPACK FOOTER //
// src/components/my_link_btn/index.vue